module.exports = __webpack_public_path__ + "static/media/login-2.40e150e1.png";